/* eslint-disable camelcase */
import axios from 'axios';
import { GIFT_TABLE_ROOT as ROOT, BASE_PATH_API } from 'constants/env';
import { wapLink } from '../../constants/Wap/index';
import { transformArrayWithId } from 'util/transformHelpers';
import {
  transformListParams,
  transformListParamsWap,
  transformListRes,
} from 'services/commons/transformers';
import { giftTableTransformer, giftTableTransformerWap } from './transformer';

export async function getGiftTable(params = {}) {
  const url = `${BASE_PATH_API}/${ROOT}/gift-table`;
  const res = await axios({ url, params: transformListParams(params) });
  const { data, pagination } = res.data;

  const transformedGiftsTables = giftTableTransformer(data);
  const giftsTablesWithId = transformArrayWithId(
    transformedGiftsTables,
    'evento'
  );

  return transformListRes(giftsTablesWithId, pagination);
}

export async function getGiftTableWap(params = {}) {
  const url = `${wapLink}events/`;
  const res = await axios({ url, params: transformListParamsWap(params) });
  let { data } = res.data;

  const transformedGiftsTables = giftTableTransformerWap(data);
  const giftsTablesWithId = transformedGiftsTables ? transformArrayWithId(
    transformedGiftsTables,
    'evento'
  ) : [];

  const pagination = {
    items_per_page: 10,
    current_page: giftsTablesWithId.length ? params.page : 0,
    total_items: giftsTablesWithId.length ? +data.totalPages * 10 : 0,
    total_pages: giftsTablesWithId.length ? +data.totalPages : 0,
  }
  
  return transformListRes(giftsTablesWithId, pagination);

}

export async function deleteGiftTable({ id, ...data }) {
  const url = `${BASE_PATH_API}/${ROOT}/gift-table/${id}/cancel`;
  const res = await axios({ url, method: 'PATCH', data });
  return res.data.data;
}

export async function getThanksMessageTypes() {
  const url = `${BASE_PATH_API}/${ROOT}/type-thanks-message`;
  const res = await axios({ url });
  return res.data.data;
}

export async function getImageGallery(eventId) {
  const url = `${BASE_PATH_API}/${ROOT}/image-gallery?event_id=${eventId}`;
  const res = await axios({ url });
  return res.data.data;
}
